import { useContext } from 'react';
import { AuthStore } from '../context';

export function useAuthToken() {
  const { state } = useContext(AuthStore);
  return {
    authToken: (state.auth && state.auth.token) || null
  };
}
